"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Analytics = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Analytics = ({
  size = 22,
  width = size,
  height = size,
  fill = '#121213',
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 14 22",
  fill: fill,
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 0 0.00737247 0.995702 16.0931 15.9154)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 0 0.00737247 0.995702 9.0941 15.9154)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 -7.9395e-08 0.00737238 0.995702 9.0941 8.91535)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 -7.9395e-08 0.00737238 0.995702 16.0912 8.91535)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 0 0.00737247 0.995702 1.90709 15.9154)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.79238",
  ry: "1.80985",
  transform: "matrix(1.00425 -7.9395e-08 0.00737238 0.995702 16.0892 2.08332)",
  fill: "#121213"
}));

exports.Analytics = Analytics;